import { Accordion } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
export default function FilterFaqGallary() {
	return (
		<div className="section fugu-section-padding2">
			<div className="container">
				<div className="fugu-section-title">
					<h2>Ask any questions related to our services or products</h2>
				</div>

				<Tabs defaultActiveKey="general" className="fugu-tab-menu">
					<Tab eventKey="general" title="General Question">
						<div className="row">
							<div className="col-md-6">
								<Accordion defaultActiveKey="0" className="nexto-accordion-one">
									<Accordion.Item eventKey="0">
										<Accordion.Header>What is an NFT?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="1">
										<Accordion.Header>What makes an NFT valuable?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="2">
										<Accordion.Header>
											What’s the connection between NFTs & crypto?
										</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>
							</div>
							<div className="col-md-6">
								<Accordion>
									<Accordion.Item eventKey="0">
										<Accordion.Header>What is an NFT?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="1">
										<Accordion.Header>What makes an NFT valuable?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="2">
										<Accordion.Header>
											What’s the connection between NFTs & crypto?
										</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>
							</div>
						</div>
					</Tab>
					<Tab eventKey="account" title="Account & Support">
						<div className="row">
							<div className="col-md-6">
								<Accordion defaultActiveKey="0" className="nexto-accordion-one">
									<Accordion.Item eventKey="0">
										<Accordion.Header>What is an NFT?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="1">
										<Accordion.Header>What makes an NFT valuable?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="2">
										<Accordion.Header>
											What’s the connection between NFTs & crypto?
										</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>
							</div>
							<div className="col-md-6">
								<Accordion>
									<Accordion.Item eventKey="0">
										<Accordion.Header>What is an NFT?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="1">
										<Accordion.Header>What makes an NFT valuable?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="2">
										<Accordion.Header>
											What’s the connection between NFTs & crypto?
										</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>
							</div>
						</div>
					</Tab>
					<Tab eventKey="returns" title="Returns Policy">
						<div className="row">
							<div className="col-md-6">
								<Accordion defaultActiveKey="0" className="nexto-accordion-one">
									<Accordion.Item eventKey="0">
										<Accordion.Header>What is an NFT?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="1">
										<Accordion.Header>What makes an NFT valuable?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="2">
										<Accordion.Header>
											What’s the connection between NFTs & crypto?
										</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>
							</div>
							<div className="col-md-6">
								<Accordion>
									<Accordion.Item eventKey="0">
										<Accordion.Header>What is an NFT?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="1">
										<Accordion.Header>What makes an NFT valuable?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="2">
										<Accordion.Header>
											What’s the connection between NFTs & crypto?
										</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>
							</div>
						</div>
					</Tab>

					<Tab eventKey="technical" title="Technical Methods">
						<div className="row">
							<div className="col-md-6">
								<Accordion defaultActiveKey="0" className="nexto-accordion-one">
									<Accordion.Item eventKey="0">
										<Accordion.Header>What is an NFT?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="1">
										<Accordion.Header>What makes an NFT valuable?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="2">
										<Accordion.Header>
											What’s the connection between NFTs & crypto?
										</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>
							</div>
							<div className="col-md-6">
								<Accordion>
									<Accordion.Item eventKey="0">
										<Accordion.Header>What is an NFT?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="1">
										<Accordion.Header>What makes an NFT valuable?</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
									<Accordion.Item eventKey="2">
										<Accordion.Header>
											What’s the connection between NFTs & crypto?
										</Accordion.Header>
										<Accordion.Body>
											At the most basic level, a non-fungible token is a one-of-a-kind, verifiable
											digital asset that can be exchanged between a creator and a buyer.
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>
							</div>
						</div>
					</Tab>
				</Tabs>
			</div>
		</div>
	);
}
